import { baseURL } from "../../../configurations/environment";
import Axios from "axios";
import { RequestConfig } from "../../RequestConfig";

export const deleteSource = async (data) => {
  let requestURL = baseURL + `/api/lead/source`;
  try {
    const response = await Axios.delete(requestURL, {
      data,
      ...RequestConfig(),
    });
    return {
      status: true,
      message: response?.message,
      data: response?.data
    };
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message,
    };
  }
};
